export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7789.de84e58f.jpg";